export default [
  {
    path: '',
    name: 'product category list',
    component: () => import('@/views/app/product-category/list/page-list.vue'),
    meta: { title: 'Daftar Kategori Produk' },
  },
  {
    path: 'tambah',
    name: 'product category create',
    component: () => import('@/views/app/product-category/create/page-create.vue'),
    meta: { title: 'Tambah Kategori Produk' },
  },
  {
    path: ':id/edit',
    name: 'product category edit',
    component: () => import('@/views/app/product-category/edit/page-edit.vue'),
    meta: { title: 'Edit Kategori Produk' },
  },
]
